import Component from "@ember/component"
import { computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import findMany from "cc-frontend/helpers/find-many"
import hasMany from "cc-frontend/helpers/has-many-collectively"
import _ from "lodash"

export default class ClassWebsiteDayComponent extends Component {
  @service("ember-store") store

  @hasMany("classWebsite", "course", "courses") courses
  @findMany("lessonIds", "class-website-lesson") lessons
  @belongsTo("classWebsite", "planbook") planbook
  @belongsTo("planbook", "rotationCalendar") rotationCalendar

  @computed("classWebsite.relationships.courses.data")
  get classWebsiteCourseIds() {
    if (get(this, "classWebsite") === undefined) return []
    return _.map(
      // get(get(get(get(this, "classWebsite.content"), "relationships"), "courses"), "data"),
      get(this, "classWebsite.relationships.courses.data"),
      (course) => get(course, "id")
    )
  }

  @computed("courses.isFulfilled", "dateString")
  get lessonIds() {
    let dateString = get(this, "dateString")

    return _.chain(get(this, "courses.content"))
      .compact()
      .map((course) => {
        return _.find(get(course, "attributes.calendar.dates"), (date) => {
          return get(date, "attributes.dateString") === dateString
        })
      })
      .compact()
      .map((courseDate) => get(courseDate, "attributes.cardStackId"))
      .value()
  }

  @computed("lessons.isFulfilled", "courses.isFufilled")
  get coursesWithoutLessons() {
    return _.chain(get(this, "courses.content"))
      .compact()
      .reject((course) => {
        let lesson = _.find(_.compact(get(this, "lessons.content")), (lesson) => {
          return get(lesson, "relationships.course.data.id") === get(course, "id")
        })
        return lesson !== undefined
      })
      .value()
  }

  @computed("lessons.isFulfilled", "courses.isFufilled")
  get coursesWithLessons() {
    return _.chain(get(this, "courses.content"))
      .compact()
      .filter((course) => {
        let lesson = _.find(_.compact(get(this, "lessons.content")), (lesson) => {
          return get(lesson, "relationships.course.data.id") === get(course, "id")
        })
        return lesson !== undefined
      })
      .value()
  }
}
